import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Text from '../../containers/Text';
import './HomePage.scss';
import { Headphones } from 'lucide-react';
import { Routes } from '../../api/routes';

const InquiriesSection = () => {
  const { t } = useTranslation();

  return (
    <section className="inquiries-section">
      <h3 className="inquiries-title">
        <Text text={t('inquiries-title')} />
      </h3>
      <div className="inquiries-grid">
        {/* Invoice Request */}
        <Link to={Routes.invoiceRequest} className="inquiry-card invoice-card">
          <div className="card-icon invoice-icon">
            <Text
              text={
                <i data-lucide="file-text" className="w-8 h-8 text-green-600" />
              }
            />
          </div>
          <h4 className="card-title">
            <Text text={t('invoice-request-title')} />
          </h4>
          <p className="card-description">
            <Text text={t('invoice-request-description')} />
          </p>
        </Link>

        {/* Expense Request */}
        <Link to={Routes.expenseRequest} className="inquiry-card expense-card">
          <div className="card-icon expense-icon">
            <Text
              text={
                <i data-lucide="receipt" className="w-8 h-8 text-blue-600" />
              }
            />
          </div>
          <h4 className="card-title">
            <Text text={t('expense-request-title')} />
          </h4>
          <p className="card-description">
            <Text text={t('expense-request-description')} />
          </p>
        </Link>

        {/* Service Call */}
        <Link to={Routes.serviceCall} className="inquiry-card service-card">
          <div className="card-icon service-icon">
            <Headphones />
          </div>
          <h4 className="card-title">
            <Text text={t('service-call-title')} />
          </h4>
          <p className="card-description">
            <Text text={t('service-call-description')} />
          </p>
        </Link>
      </div>
    </section>
  );
};

export default InquiriesSection;
